import { render, staticRenderFns } from "./mortgage-index.vue?vue&type=template&id=0be1d5fa"
import script from "./mortgage-index.vue?vue&type=script&lang=js"
export * from "./mortgage-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports